import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-iphone-app-dev',
  templateUrl: './iphone-app-dev.component.html',
  styleUrls: ['./iphone-app-dev.component.css']
})
export class IphoneAppDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/iphone-app-dev/iphone-app-dev.component.ts